// 站点基础信息与栏目导航
export const site = {
  name: "吃瓜路线",
  shortName: "吃瓜路线",
  slogan: "把散落的线索，串成一张清楚的事件地图",
  englishName: "ChiGua LuXian",
  description:
    "吃瓜路线是一个面向全网公众的「事件整理」内容平台，用时间线、人物关系、观点光谱与信息溯源，把复杂的公共讨论串成清楚的地图，帮你不做糊里糊涂的旁观者。",
  email: "hello@chigualuxian.example",
  // 栏目（瓜田分布）
  categories: [
    {
      slug: "yingshi",
      name: "影视娱乐",
      desc: "剧集、综艺、音乐、电影的话题复盘",
      icon: "ri-clapperboard-line",
    },
    {
      slug: "shangzhan",
      name: "品牌商战",
      desc: "联名、定价、公关与行业争议梳理",
      icon: "ri-store-2-line",
    },
    {
      slug: "pingtai",
      name: "平台热议",
      desc: "直播、内容、算法与平台规则之辩",
      icon: "ri-global-line",
    },
    {
      slug: "shehui",
      name: "社会话题",
      desc: "消费、价格与公共生活中的真问题",
      icon: "ri-discuss-line",
    },
  ],
  // 导航
  nav: [
    { label: "首页", path: "/" },
    { label: "事件地图", path: "/events" },
    { label: "吃瓜方法论", path: "/methodology" },
    { label: "常见问题", path: "/faq" },
    { label: "关于我们", path: "/about" },
  ],
};

export const categoryNameMap: Record<string, string> = {
  yingshi: "影视娱乐",
  shangzhan: "品牌商战",
  pingtai: "平台热议",
  shehui: "社会话题",
};

export const siteDisclaimer =
  "本站所有事件整理仅用于信息梳理与公共讨论参考，观点均来自各方公开表态，不代表本站立场。请以官方公告与权威信源为准，理性讨论、谨慎转发。";

export type HotTopic = {
  rank: number;
  title: string;
  category: string;
  slug: string;
  heat: number;
  delta: string;
  trend: "up" | "down" | "flat";
};

// 热榜（热点坐标）
export const hotTopics: HotTopic[] = [
  {
    rank: 1,
    title: "「半醒」与「云梯」联名争议全记录",
    category: "品牌商战",
    slug: "banxing-guochao",
    heat: 96,
    delta: "上升 12 位",
    trend: "up",
  },
  {
    rank: 2,
    title: "一档音综的「剪辑争议」事件地图",
    category: "影视娱乐",
    slug: "changxiu-jiansha",
    heat: 91,
    delta: "上升 8 位",
    trend: "up",
  },
  {
    rank: 3,
    title: "直播间「断货回锅」风波时间线",
    category: "平台热议",
    slug: "zhibo-jianglai",
    heat: 84,
    delta: "下降 1 位",
    trend: "down",
  },
  {
    rank: 4,
    title: "网友发现的「羊毛价差」讨论合集",
    category: "社会话题",
    slug: "wanlu-dingjia",
    heat: 79,
    delta: "上升 5 位",
    trend: "up",
  },
  {
    rank: 5,
    title: "电影贴片广告引热议，片方致歉始末",
    category: "影视娱乐",
    slug: "dianying-guanggao",
    heat: 72,
    delta: "持平",
    trend: "flat",
  },
  {
    rank: 6,
    title: "AI 换脸短视频惹争议，平台出新规",
    category: "平台热议",
    slug: "shanshi-renzhi",
    heat: 66,
    delta: "下降 4 位",
    trend: "down",
  },
];